<template>
    <div class="col-12 col-lg-6 mb-3 order-2 order-lg-1">
        <div class="card h-100 d-flex flex-column">
            <div class="d-flex">
                <div class="col-2">
                    <div class="card-body text-elev-blue">
                        <svg xmlns="http://www.w3.org/2000/svg" class="card-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                    </div>
                </div>
                <div class="col-10">
                    <div class="card-body pb-0">
                        <h5 class="fw-bold">{{ $t('Få kontoutskrift tilsendt på epost') }}</h5>
                        <div class="form-group">
                            <label for="email">{{ $t('Velg epost') }}:</label>
                            <select class="form-select" name="email" id="email" @change="setEmail" :disabled="!emails.length">
                                <option v-for="email in emails" :value="email">{{ email }}</option>
                            </select>
                        </div>
                        <div v-show="!emails.length"><small>{{ $t('Registrer epostadressen din her for å kunne bestille kontoutskrift') }}:</small> </div>

                        <div class="alert alert-danger" v-show="sendingError">{{ sendingError }}</div>
                        <div class="alert alert-success" v-show="sendingSuccess">{{ sendingSuccess }}</div>
                    </div>
                </div>
            </div>
            <div class="d-flex mt-auto">
                <div class="col-12">
                    <div class="card-body">
                        <div class="col-12">
                            <button class="btn btn-block py-2 fw-bold" :class="{'btn-primary': !isSent, 'btn-success': isSent}" @click="send" :disabled="isSending || isSent" v-show="emails.length">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="isSending"></span>
                                <span class="fas fa-check" role="status" aria-hidden="true" v-show="isSent"></span>
                                {{ sendEmailBtnLabel }}
                            </button>
                            <a v-show="!emails.length" href="/profile" class="btn btn-block py-2 fw-bold btn-primary">{{ $t('Gå til din profil') }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Store from "../../state/accountStore";

const sendingError = computed(() => Store.getSendingErrorMessage());
const sendingSuccess = computed(() => Store.getSendingSuccessMessage());
const emails = computed(() => Store.getEmails());
const isSending = computed(() => Store.isSending());
const isSent = computed(() => Store.isSent());
const sendEmailBtnLabel = computed(() => {
    if (isSent.value) {
        return $t('Sendt!');
    }
    if (isSending.value) {
        return $t('Sender...');
    }
    return $t('Send');
});

function send() {
    Store.sendSummary();
}

function setEmail(event) {
    Store.setEmail(event.target.value);
}
</script>